import styled, { css } from 'styled-components';
import { Input, inputContainerMixin } from '../Input/Input.styled';

import { TextL, TextXS } from 'ui/Styled/Styled';
import Button from 'ui/Button/Button';
import { Container as TableContainer } from 'ui/Table/Table.styled';
import { SkeletonWrapper } from 'components/Skeleton/Skeleton.styled';
import { themeable } from 'themes/utils';
import { desktopMediaQuery } from 'utils/mediaQuery';
import { textXSSize } from 'tokens';

import deleteIcon from 'assets/trash.png';

export const SearchField = styled(Input)`
    background: rgba(45, 48, 62, 0.5);
    backdrop-filter: blur(36px);
`;

export const SearchRow = styled.div`
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    z-index: 10;
    position: sticky;
    top: 24px;
    left: 0;
`;

export const SearchRowButtons = styled.div`
    background: linear-gradient(
        to bottom,
        ${themeable('mainBackgroundColor')} calc(100% - 24px),
        transparent 100%
    );
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: center;
    gap: 10px;
    height: 100%;

    & > *:first-child {
        margin-left: 10px;
    }
`;

export const SearchRowActionButton = styled(Button)`
    min-width: unset;
`;

export const ToggleEditModeButton = styled(Button)`
    min-width: 120px;
`;

export const Container = styled.div<{
    $disableHorizontalScroll?: boolean;
    $disableVerticalScroll?: boolean;
    $hasSearch?: boolean;
    $hasSkeleton?: boolean;
    $hasPagination?: boolean;
}>`
    height: 100%;
    overflow: auto;

    display: flex;
    flex-flow: column;
    margin: 0 -24px;
    padding: 0 24px;

    ${({ $hasSearch }) =>
        $hasSearch &&
        css`
            & ${TableContainer} {
                padding-top: 28px;

                margin-top: 8px;
            }

            & ${SkeletonWrapper} {
                padding-top: 40px;
            }
        `}

    ${({ $disableHorizontalScroll, $hasSearch }) =>
        $disableHorizontalScroll &&
        !$hasSearch &&
        desktopMediaQuery(css`
            overflow-x: hidden;
        `)}

    ${({ $disableVerticalScroll }) =>
        $disableVerticalScroll &&
        css`
            overflow-y: hidden;
        `}

    &::-webkit-scrollbar {
        width: 3px; /* Убираем ширину скроллбара */
    }
`;

export const TableHeader = styled.header<{ $hasMargin?: boolean }>`
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: center;
    position: relative;
    gap: 10px;

    ${({ $hasMargin }) =>
        $hasMargin &&
        css`
            margin-bottom: 24px;
        `}
`;

export const TableBefore = styled.div`
    flex: 1;
`;

export const DeleteActionButton = styled(SearchRowActionButton)``;

export const DeleteButton = styled.img`
    width: 100%;
    height: auto;
    margin: -2px;
    cursor: pointer;
    content: url(${deleteIcon});

    transform: translateX(150%);
    transition: transform 100ms;
    position: relative;
`;

export const DeleteHoverArea = styled.div`
    position: absolute;
    left: -30px;
    right: -20px;
    top: 0;
    bottom: 0;
`;

export const DeleteButtonContainer = styled.div`
    margin-right: -38px;
    transition: margin 100ms;

    width: 24px;
    height: auto;
    position: relative;
    display: flex;
    align-items: center;

    &:has(${DeleteHoverArea}:hover),
    &:has(${DeleteButton}:hover) {
        margin-right: -10px;
    }

    &:hover
        ${DeleteButton},
        &
        ${DeleteHoverArea}:hover+${DeleteButton},
        &
        ${DeleteButton}:hover {
        transform: none;
    }
`;

export const DeletePopupTitle = styled(TextL)`
    margin-bottom: 24px;
    text-align: center;
`;

export const DeletePopupButton = styled(Button)`
    span {
        text-transform: uppercase;
    }
`;

export const PaginationContainer = styled(TextXS)`
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: center;
    height: 70px;
    gap: 20px;
    /* background: linear-gradient(
        to top,
        ${themeable('mainBackgroundColor')} 0%,
        ${themeable('mainBackgroundColor')} 70%,
        transparent 100%
    ); */
`;

export const PaginationPagesCount = styled.div<SActiveProps>`
    ${({ $active }) =>
        $active &&
        css`
            cursor: pointer;

            &:hover {
                color: ${themeable('primaryColor')};
            }
        `}
`;

export const PaginationMain = styled.div`
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: center;
    gap: 16px;
`;

export const PaginationInput = styled.input`
    ${inputContainerMixin}

    min-width: unset;
    aspect-ratio: 1;
    text-align: center;
    width: 30px;
    border-radius: 7px;
    font-size: ${textXSSize};
    height: unset;
    padding: 7px 0;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`;

export const PaginationPart = styled.div`
    flex: 1;
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;

    color: ${themeable('primaryColor')};

    & > * {
        cursor: pointer;
        height: 100%;
    }
`;

export const PaginationRightPart = styled(PaginationPart)`
    justify-content: flex-start;
`;
